import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var GlobeIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M0,0H24V24H0Z",
    fill: "none"
  }), /*#__PURE__*/_jsx("path", {
    d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M10.85,3.1c0,.4,0,.69,0,1.61s1.61,1,1.61,2.44S10,8.31,8.48,8.31A2.53,2.53,0,0,0,6,11a2.53,2.53,0,0,0,2.48,2.64c1.29,0,1.33.62,1.33,1.7s.07,3,1.61,3,1.79-2.19,2.66-3.46,1.52-2.5.48-2.5c-.75,0-.58-.73-.58-1.23s-1.2-1.09-.69-1.33a7.6,7.6,0,0,1,2.36-.15C17.1,9.64,18,6.11,18,6.11S16.4,2.67,10.85,3.1Z"
  })]
}), 'GlobeIcon');